<template>
  <ul class="menu-nav">
    <router-link to="/" v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-architecture-and-city"></i>
          <span class="menu-text">داشبورد</span>
        </a>
      </li>
    </router-link>

    <router-link
      :to="{ name: 'destinations-index' }"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-speaker"></i>
          <span class="menu-text">مقصد‌ها</span>
        </a>
      </li>
    </router-link>

    <router-link
      :to="{ name: 'programs-index' }"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fal fa-film"></i>
          <span class="menu-text">برنامه‌‌ها</span>
        </a>
      </li>
    </router-link>

    <router-link
      v-if="isOperator"
      :to="{ name: 'channels-index' }"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fal fa-tv"></i>
          <span class="menu-text">کانال من</span>
        </a>
      </li>
    </router-link>

    <template v-if="showFinancialPart">
      <li class="menu-section">
        <h4 class="menu-text">مالی</h4>
        <i class="menu-icon flaticon-more-v2"></i>
      </li>

      <router-link
        :to="{ name: 'transactions-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-credit-card"></i>
            <span class="menu-text">تراکنش‌ها</span>
          </a>
        </li>
      </router-link>
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
        v-bind:class="{
          'menu-item-open': hasActiveChildren('/receipts')
        }"
      >
        <a href="#" class="menu-link menu-toggle">
          <i class="menu-icon flaticon-notes"></i>
          <span class="menu-text">رسیدها</span>
          <i class="menu-arrow"></i>
        </a>
        <div class="menu-submenu menu-submenu-classic menu-submenu-right">
          <ul class="menu-subnav">
            <router-link
              :to="{ name: 'receipts-lives-index' }"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot"><span></span></i>
                  <span class="menu-text">رسید پخش</span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </li>
    </template>
    <template v-if="isCompanyOwner">
      <li class="menu-section">
        <h4 class="menu-text">سازمانی</h4>
        <i class="menu-icon flaticon-more-v2"></i>
      </li>

      <router-link
        :to="{ name: 'company-dashboard' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-architecture-and-city"></i>
            <span class="menu-text">داشبورد</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'company-active-lives' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-play-circle"></i>
            <span class="menu-text">پخش های فعال</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'company-lives' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-play"></i>
            <span class="menu-text">پخش ها</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'company-programs-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-tv"></i>
            <span class="menu-text">برنامه‌‌ها</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'company-destinations-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-speaker"></i>
            <span class="menu-text">مقصد‌ها</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'company-users-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon-users"></i>
            <span class="menu-text">کاربران</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'company-banned-users-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-user-slash"></i>
            <span class="menu-text">کاربران بلاک شده</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'company-banners-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-ad"></i>
            <span class="menu-text">بنرها</span>
          </a>
        </li>
      </router-link>
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
        v-bind:class="{
          'menu-item-open': hasActiveChildren('/company/receipts')
        }"
      >
        <a href="#" class="menu-link menu-toggle">
          <i class="menu-icon flaticon-notes"></i>
          <span class="menu-text">رسیدها</span>
          <i class="menu-arrow"></i>
        </a>
        <div class="menu-submenu menu-submenu-classic menu-submenu-right">
          <ul class="menu-subnav">
            <router-link
              :to="{ name: 'company-receipts-lives-index' }"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot"><span></span></i>
                  <span class="menu-text">رسید پخش</span>
                </a>
              </li>
            </router-link>

            <router-link
              :to="{ name: 'company-receipts-storage-index' }"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot"><span></span></i>
                  <span class="menu-text">رسید فضای ابری</span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </li>
    </template>

    <template v-if="isOperator">
      <li class="menu-section">
        <h4 class="menu-text">مدیریت</h4>
        <i class="menu-icon flaticon-more-v2"></i>
      </li>
      <router-link
        :to="{ name: 'admin-dashboard' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-architecture-and-city"></i>
            <span class="menu-text">داشبورد</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'admin-active-lives' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-play-circle"></i>
            <span class="menu-text">پخش های فعال</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'admin-lives' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-play"></i>
            <span class="menu-text">پخش ها</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'admin-programs-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-tv"></i>
            <span class="menu-text">برنامه‌‌ها</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'admin-destinations-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon2-speaker"></i>
            <span class="menu-text">مقصد‌ها</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'admin-companies-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-building"></i>
            <span class="menu-text">شرکت ها</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'admin-users-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon flaticon-users"></i>
            <span class="menu-text">کاربران</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'admin-banned-users-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-user-slash"></i>
            <span class="menu-text">کاربران بلاک شده</span>
          </a>
        </li>
      </router-link>
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
        v-bind:class="{
          'menu-item-open': hasActiveChildren('/admin/receipts')
        }"
      >
        <a href="#" class="menu-link menu-toggle">
          <i class="menu-icon fal fa-file-invoice-dollar"></i>
          <span class="menu-text">مالی</span>
          <i class="menu-arrow"></i>
        </a>
        <div class="menu-submenu menu-submenu-classic menu-submenu-right">
          <ul class="menu-subnav">
            <router-link
              :to="{ name: 'admin-transactions-index' }"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot"><span></span></i>
                  <span class="menu-text">تراکنش‌ها</span>
                </a>
              </li>
            </router-link>
            <router-link
              :to="{ name: 'admin-special-users' }"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot"><span></span></i>
                  <span class="menu-text">کاربران ویژه</span>
                </a>
              </li>
            </router-link>
            <router-link
              :to="{ name: 'admin-receipts-lives-index' }"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot"><span></span></i>
                  <span class="menu-text">رسید پخش</span>
                </a>
              </li>
            </router-link>
            <router-link
              :to="{ name: 'admin-receipts-storage-index' }"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot"><span></span></i>
                  <span class="menu-text">رسید فضای ابری</span>
                </a>
              </li>
            </router-link>
            <router-link
              :to="{ name: 'admin-pricing' }"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot"><span></span></i>
                  <span class="menu-text">مدیریت قیمت‌ها</span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </li>
      <router-link
        :to="{ name: 'admin-reports-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-flag"></i>
            <span class="menu-text">گزارشات</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'admin-messages-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-comment-alt"></i>
            <span class="menu-text">تماس‌با‌ما</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'admin-banners-index' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fal fa-ad"></i>
            <span class="menu-text">بنرها</span>
          </a>
        </li>
      </router-link>
      <router-link
        :to="{ name: 'admin-gift-cards' }"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fa fa-gift" aria-hidden="true"></i>
            <span class="menu-text">کارت هدیه</span>
          </a>
        </li>
      </router-link>
    </template>
  </ul>
</template>

<script>
export default {
  name: "KTMenu",
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  }
};
</script>
